import { useEffect, useRef, type RefObject } from 'react'

// A ref that always holds the most recent `value`, for callbacks that must not
// be rebuilt when it changes — a gesture handler bound with a non-passive
// native listener, a memoized handler object, an auth snapshot read from a
// close handler that runs after the state it describes has been cleared.
//
// The write happens in an effect rather than during render, so the ref is only
// ever updated from a render React actually committed. Read `.current` from
// callbacks and effects; reading it during render returns the previous
// committed value and defeats the point.
export function useLatestRef<T>(value: T): RefObject<T> {
  const ref = useRef(value)
  useEffect(() => {
    ref.current = value
  })
  return ref
}
